// 路由配置
import Vue from 'vue';
//引入vue-router
import VueRouter from 'vue-router';
//第三方库需要use一下才能用
Vue.use(VueRouter)
const RouterConfig = {
	esModule: false,
	mode: 'hash',
	base: process.env.publicPath,
	routes: [{
			path: '/',
			component: (resolve) => require(['./pages/index.vue'], resolve),
			meta: {
				requireAuth: true,
			},
			redirect: to => {
				return '/main';
			},
			children: [{
					path: '/main',
					component: (resolve) => require(['./pages/main.vue'], resolve),
					meta: {
						title: "主页",
						requireAuth: true,
					}
				},
				{
					path: '/crm/customer',
					component: (resolve) => require(['./pages/crm/customer/list.vue'], resolve),
					meta: {
						title: "客户管理",
						requireAuth: true,
						navIndex: '4-3'
					}
				},
				{
					path: '/crm/customer/add',
					component: (resolve) => require(['./pages/crm/customer/add.vue'], resolve),
					meta: {
						title: "新建客户",
						requireAuth: true,
						navIndex: '4-3'
					}
				},
				{
					path: '/crm/customer/list',
					component: (resolve) => require(['./pages/crm/customer/list.vue'], resolve),
					meta: {
						title: "客户列表",
						requireAuth: true,
						navIndex: '4-3'
					}
				},
				{
					path: '/crm/customer/view/:id',
					component: (resolve) => require(['./pages/crm/customer/view.vue'], resolve),
					meta: {
						title: "查看客户详情",
						requireAuth: true,
						navIndex: '4-3'
					}
				},
				{
					path: '/crm/contacter',
					component: (resolve) => require(['./pages/crm/contacter/index.vue'], resolve),
					meta: {
						title: "联系人管理",
						requireAuth: true,
						navIndex: '4-4'
					}
				},
				{
					path: '/crm/contacter/view/:id',
					component: (resolve) => require(['./pages/crm/contacter/view.vue'], resolve),
					meta: {
						title: "查看联系人详情",
						requireAuth: true,
						navIndex: '4-4'
					}
				},
				{
					path: '/contract/class',
					component: (resolve) => require(['./pages/contract/class/index.vue'], resolve),
					meta: {
						title: "合同分类管理",
						requireAuth: true,
						navIndex: '3-0-1'
					}
				},
				{
					path: '/contract/archive/list',
					component: (resolve) => require(['./pages/contract/archive/list.vue'], resolve),
					meta: {
						title: "合同列表",
						requireAuth: true,
						navIndex: '3-1-1'
					}
				},
				{
					path: '/order/list',
					component: (resolve) => require(['./pages/order/list.vue'], resolve),
					meta: {
						title: "订单管理",
						requireAuth: true,
						navIndex: '5-1'
					}
				},
				{
					path: '/order/add',
					component: (resolve) => require(['./pages/order/add.vue'], resolve),
					meta: {
						title: "提交订单",
						requireAuth: true,
						navIndex: '5-1'
					}
				},
				{
					path: '/contract/archive/add',
					component: (resolve) => require(['./pages/contract/archive/add.vue'], resolve),
					meta: {
						title: "上传合同",
						requireAuth: true,
						navIndex: '1-1'
					}
				},
				{
					path: '/contract/archive/view/:id',
					component: (resolve) => require(['./pages/contract/archive/view.vue'], resolve),
					meta: {
						title: "查看合同",
						requireAuth: true,
						navIndex: '1-1'
					}
				},
				{
					path: '/service/list',
					component: (resolve) => require(['./pages/service/list.vue'], resolve),
					meta: {
						title: "服务管理",
						requireAuth: true,
						navIndex: '6-1'
					}
				},
				{
					path: '/service/add',
					component: (resolve) => require(['./pages/service/add.vue'], resolve),
					meta: {
						title: "添加服务",
						requireAuth: true,
						navIndex: '6-1'
					}
				},
				{
					path: '/service/view/:id',
					component: (resolve) => require(['./pages/service/view.vue'], resolve),
					meta: {
						title: "查看服务详情",
						requireAuth: true,
						navIndex: '6-1'
					}
				},
				{
					path: '/service/dljz/add',
					component: (resolve) => require(['./pages/service/dljz/add.vue'], resolve),
					meta: {
						title: "新建代理记账服务",
						requireAuth: true,
						navIndex: '6-6'
					}
				},
				{
					path: '/service/dljz/list',
					component: (resolve) => require(['./pages/service/dljz/list.vue'], resolve),
					meta: {
						title: "代理记账服务列表",
						requireAuth: true,
						navIndex: '6-6'
					}
				},
				{
					path: '/service/dljz/view/:id',
					component: (resolve) => require(['./pages/service/dljz/view.vue'], resolve),
					meta: {
						title: "查看代理记账服务详情",
						requireAuth: true,
						navIndex: '6-6'
					}
				},
				{
					path: '/finance/receipt',
					name: 'finance.receipt',
					component: (resolve) => require(['./pages/finance/receipt/details.vue'], resolve),
					meta: {
						title: "收款单",
						requireAuth: true,
						navIndex: '8-2'
					}
				},
				{
					path: '/finance/account/details',
					component: (resolve) => require(['./pages/finance/account/details.vue'], resolve),
					meta: {
						title: "账户变动记录",
						requireAuth: true,
					}
				},
				{
					path: '/hr/employee/add',
					component: (resolve) => require(['./pages/hr/employee/list.vue'], resolve),
					meta: {
						title: "添加人员",
						requireAuth: true,
						navIndex: '9-1'
					}
				},
				{
					path: '/hr/employee/view',
					component: (resolve) => require(['./pages/hr/employee/list.vue'], resolve),
					meta: {
						title: "人员详情",
						requireAuth: true,
						navIndex: '9-1'
					}
				},
				{
					path: '/hr/department',
					component: (resolve) => require(['./pages/hr/department/index.vue'], resolve),
					meta: {
						title: "组织架构",
						requireAuth: true,
						navIndex: '9-1'
					}
				},
				{
					path: '/hr/department/dingTalk',
					component: (resolve) => require(['./pages/hr/department/dingTalk.vue'], resolve),
					meta: {
						title: "钉钉同步",
						requireAuth: true,
						navIndex: '9-2'
					}
				},
				{
					path: '/hr/department/qywx',
					component: (resolve) => require(['./pages/hr/department/qywx.vue'], resolve),
					meta: {
						title: "企业微信同步",
						requireAuth: true,
						navIndex: '9-3'
					}
				},
				{
					path: '/manager/product/',
					component: (resolve) => require(['./pages/manager/product/index.vue'], resolve),
					meta: {
						title: "产品管理",
						requireAuth: true,
						navIndex: '99-1'
					}
				},
				{
					path: '/manager/product/add',
					component: (resolve) => require(['./pages/manager/product/add.vue'], resolve),
					meta: {
						title: "添加产品",
						requireAuth: true,
						navIndex: '99-1'
					}
				},
				{
					path: '/manager/user',
					component: (resolve) => require(['./pages/manager/user/index.vue'], resolve),
					meta: {
						title: "账号管理",
						requireAuth: true,
						navIndex: '99-2'
					}
				},
				{
					path: '/manager/setting/sms',
					component: (resolve) => require(['./pages/manager/setting/sms.vue'], resolve),
					meta: {
						title: "短信设置",
						requireAuth: true,
						navIndex: '99-9'
					}
				},
				{
					path: '/user',
					component: (resolve) => require(['./pages/user/index.vue'], resolve),
					meta: {
						title: "个人资料",
						requireAuth: true,
					}
				}
			]
		},
		{
			path: '/login',
			component: (resolve) => require(['./pages/login.vue'], resolve),
			meta: {
				title: "登陆",
				requireAuth: false,
			}
		}
	]
};
const router = new VueRouter(RouterConfig);
export default router
